// src/Screens/configuration/ConfigurationHistoryScreen.tsx

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CircularProgress,
  Button,
  Stack,
} from "@mui/material";
import EnhancedPageTitle from "../../Component/EnhancedPageTitle";
import { getConfigurationHistory } from "../../services/configurationHistoryService";
import HistoryIcon from "@mui/icons-material/History";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

// API response item structure
interface RawHistoryItem {
  configurationHistoryId: number;
  configurationId: number;
  value: number;
  effectiveFrom: string;
  effectiveTo: string;
  modifiedOn: string;
}

// Grouped data for display
interface GroupedHistory {
  conversionValue?: number;
  incentiveValue?: number;
  effectiveFrom: string;
  effectiveTo: string;
}

const ConfigurationHistoryScreen: React.FC = () => {
  const [history, setHistory] = useState<GroupedHistory[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

 
    useEffect(() => {
  setLoading(true);
    const fetchHistory = async () => {
      try {
        const data: RawHistoryItem[] = await getConfigurationHistory();

        const grouped: GroupedHistory[] = [];

        data.forEach((item) => {
          const match = grouped.find(
            (entry) =>
              entry.effectiveFrom === item.effectiveFrom &&
              entry.effectiveTo === item.effectiveTo
          );

          if (match) {
            if (item.configurationId === 1) {
              match.conversionValue = item.value;
            } else if (item.configurationId === 2) {
              match.incentiveValue = item.value;
            }
          } else {
            grouped.push({
              conversionValue: item.configurationId === 1 ? item.value : undefined,
              incentiveValue: item.configurationId === 2 ? item.value : undefined,
              effectiveFrom: item.effectiveFrom,
              effectiveTo: item.effectiveTo,
            });
          }
        });

        grouped.sort(
          (a, b) =>
            new Date(b.effectiveFrom).getTime() - new Date(a.effectiveFrom).getTime()
        );

        setHistory(grouped);
      } catch (error) {
        alert("Failed to fetch configuration history");
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  return (
    <Box sx={{ bgcolor: "#f0f2f5", p: 3, minHeight: "100vh" }}>
      <Card sx={{ p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
          <EnhancedPageTitle title="Configuration History" icon={<HistoryIcon />} />
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/configurationscreen")}
          >
            Back
          </Button>
        </Stack>

        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" py={5}>
            <CircularProgress />
          </Box>
        ) : history.length === 0 ? (
          <Typography>No history data found.</Typography>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Conversion Rate (USD/INR)</TableCell>
                <TableCell>Incentive (%)</TableCell>
                <TableCell>Effective From</TableCell>
                <TableCell>Effective To</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{item.conversionValue ?? "-"}</TableCell>
                  <TableCell>{item.incentiveValue ?? "-"}</TableCell>
                  <TableCell>{item.effectiveFrom}</TableCell>
                  <TableCell>{item.effectiveTo}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </Box>
  );
};

export default ConfigurationHistoryScreen;
